export function Transactions() {
  return (
    <div>
      <h1 className="text-[24px] font-semibold tracking-tight leading-[1.2]">Transactions</h1>
      <p className="text-swiss-gray-500 mt-2 text-[14px]">
        View and manage all transactions across your entities.
      </p>
    </div>
  )
}
